import { Component, Input } from '@angular/core';

@Component({
  selector: 'afoone-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.css']
})
export class DashboardCardComponent {
  @Input() title = 'Dashboard Card';
  @Input() description = 'This is a dashboard card component.';
  @Input() imgSrc = 'assets/img/apps/default.png';
  @Input() link = '#';

  navigate() {
    window.open(this.link, '_blank');
  }

}
